export default __webpack_public_path__ + "static/media/Meat Gear Enhance.85b8df8f.png";